import axios from "../common";

export const ApiCoverageInputParameters = async () => {
    return await axios.get("/coverage_simulator/parameters/list", {withCredentials: true})
}

export const ApiSetCoverageInputParameterValue = async (id: number, value: string) => {
    return await axios.put(`/coverage_simulator/parameters/${id}/update/`, {value: value}, {withCredentials: true})
}

export const ApiMassLoadCoverageParameterFile = async (name: string, file: Blob, mode: string) => {
    let _u = '/coverage_simulator/' + name.replace('_', '/') + '/upload/?summarize&loading_mode=' + mode
    return await axios.post(_u, {file: file}, {withCredentials: true, headers: {'Content-Type': 'multipart/form-data'}}) 
}

export const ApiCheckParameters = async () => {
    return await axios.get('/coverage_simulator/parameters/check', {withCredentials: true})
}

export const ApiDownloadCoverageParameter = async (
    id: number,
    clsName: string | null = null,
    extraParams: Record<string, string> = {},
) => {
    const params = new URLSearchParams()
    if (clsName) {
        params.set('cls_name', clsName)
    }
    Object.entries(extraParams).forEach(([key, value]) => {
        if (value) {
            params.set(key, value)
        }
    })
    const qs = params.toString()
    const suffix = qs ? `?${qs}` : ''
    return await axios.get(
        `/coverage_simulator/parameters/${id}/download${suffix}`,
        { withCredentials: true, responseType: 'blob' },
    )
}
